// The shared core's JS runtime loads lazily with the first screen that needs it, so sign-out
// cannot import it; the loader registers its stop here instead.
let stopSession: (() => void) | null = null

export function onSharedCoreStarted(stop: () => void) {
  stopSession = stop
}

export function stopSharedCoreSession() {
  const stop = stopSession
  stopSession = null
  stop?.()
}
